'use client';
import { ArrowRight } from 'lucide-react';
import { useRef } from 'react';

import { ChatCommandMenu } from '@/shared/ui/chat/command-menu';
import { useCommandMenu } from '@/shared/ui/chat/use-command-menu';

import type { DialogCommand } from '../lib/commands';
import type { ControlsTrack } from '../lib/controls-analytics';
const buttonStyle =
	'flex min-h-11 items-center justify-center gap-2 rounded-lg border border-gray-4 bg-white px-3 py-2 text-sm hover:bg-gray-5 focus-visible:ring-2 focus-visible:ring-accent disabled:cursor-not-allowed disabled:opacity-40';
export function DialogCompletedActions({
	commands,
	onNext,
	nextLabel,
	message,
	track,
}: {
	commands: DialogCommand[];
	onNext: () => void;
	nextLabel: string;
	message: string;
	track: ControlsTrack;
}) {
	const anchorRef = useRef<HTMLDivElement>(null);
	const menu = useCommandMenu({
		commands,
		onExecute: (command, source) =>
			track('command', { action: command.id, source, stage: 'intent' }),
		onOpenChange: (open, source) =>
			track('menu', { action: open ? 'open' : 'close', source }),
	});
	return (
		<section aria-label="Действия после завершения задачи">
			<p role="status" className="mb-2 text-center text-sm text-gray-3">
				{message}
			</p>
			<div ref={anchorRef} className="grid grid-cols-2 gap-2">
				<ChatCommandMenu
					menu={menu}
					anchorRef={anchorRef}
					label="Меню"
					className={`${buttonStyle} h-auto w-auto`}
				/>
				{commands
					.filter((item) => item.id === 'solution' || item.id === 'restart')
					.map((item) => (
						<button
							type="button"
							key={item.id}
							className={buttonStyle}
							disabled={item.disabled}
							onClick={() => void menu.select(item)}
						>
							<item.icon size={16} />
							{item.label}
						</button>
					))}
				<button
					type="button"
					onClick={() => {
						track('navigation', { action: 'continue', stage: 'intent' });
						onNext();
					}}
					className="flex min-h-11 items-center justify-center gap-2 rounded-lg bg-green px-3 py-2 text-sm text-white hover:bg-green-300 focus-visible:ring-2 focus-visible:ring-green"
				>
					{nextLabel}
					<ArrowRight size={16} />
				</button>
			</div>
		</section>
	);
}
